export default function (state, getters, rootState, rootGetters) {
    return rootState.finances.certificates.item.form.ContragentType === 'client' ? 1 : 2;
}